<template>
    <div>
        <Navbar Title='Constitution Of India'/>


        <div class="container"><div  class="card">
            <h2 style="margin:40px 30px 0px">Constitution Of India</h2>


            <div class="container" style="padding:20px 30px">
            <div class="accordion" v-for="(part,index) in constitution" :key="index">
                <div class="accordion-item">
                    <h2 class="accordion-header ">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle='collapse'  v-bind:data-bs-target="'#'+'collapse'+index">
                           {{part.title}}
                        </button>
                    </h2>
                    <div v-bind:id="'collapse'+index" class="accordion-collapse collapse">
                        <div class="accordion-body">
                            <div class="accordion accordion-flush" v-for="(article, artIndex) in part.articles" :key="artIndex">
                                <div class="accordion-item">
                                    <div class="collapsed row" style="padding:10px;margin:0" type="button" data-bs-toggle="collapse" v-bind:data-bs-target="'#'+'flush-collapse'+index+artIndex" >
                                        <div class="col-12"><h5><b>{{article.head}}</b></h5> </div>
                                        <div class="col-12 float-md-end" v-if="article.subhead"><small>{{article.subhead}}</small></div>    
                                    </div>
                                    <div v-bind:id="'flush-collapse'+index+artIndex" class="accordion-collapse collapse">
                                        <div class="accordion-body" v-html="article.desc"></div>
                                        <div>
                                            <textarea name="description" v-model="constitution[index].articles[artIndex].desc"></textarea>
                                            <button class="btn" style="margin:30px" @click="edit(index,artIndex)">edit</button>
                                        </div>
                                        

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div></div>

        <!-- <button class="btn" style="margin:30px" @click="upload">upload</button> -->
        
    </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
// import usersData from '@/components/Project-components/Constitution/CoI.json'
import db from '@/firebase/init'

export default {
    name: 'Constitution',
    components: {
        Navbar,
    },
    data(){
        return{
            // constitution:usersData
            constitution:null,
            id:null
        }
    },
    methods:{
            // upload(){
            //     alert("hello");
            //     db.collection("Constitution").add({
            //         contents:this.constitution
            //     }).then(() => {
            //         console.log("done")
            //     }).catch(err =>{
            //         console.log(err)
            //     })
            // },
            edit(index,artIndex){
                console.log(this.constitution[index].articles[artIndex].desc, this.id)

                db.collection("Constitution").doc(this.id).update({
                    contents:this.constitution
                }).then(() => {
                    console.log("done")
                }).catch(err =>{
                    console.log(err)
                })
            }
    },
    created(){
        //fetch data from firestore
        db.collection("Constitution").get().then(snapshot => {
            snapshot.forEach(element => {
                // console.log(element.data().contents)
                this.constitution = element.data().contents;
                this.id = element.id
                
            });
            
        })
    }
}
</script>